<template>
  <div>
    <Row justify="start" type="flex">
      <Col class="buy_col01" v-for="(item, index) in photoArr1" :key="index">
        <div class="buy_rule" @click="getMoney(item)">
          <img :src="item.photoUrl" alt="#" />
        </div>
        <div @click="getMoney(item)" class="sp">{{ item.ref }}</div>
        <div style="font-size: 18px; color: #f12344; margin-bottom: 6px">
          <!--{{item.money}}-->
          <Button type="primary" @click="getMoney(item)">了解更多</Button>
          <!-- <Button type="primary" @click="getMoney01(item)">立即购买</Button> -->
        </div>
      </Col>
    </Row>
    <!--对话框-->
    <div>
      <Modal
        class="modal_div"
        v-model="modal1"
        width="80%"
        class-name="vertical-center-modal"
        @on-visible-change="onChange"
      >
        <div slot="header">
          <Row>
            <Col span="20">
              <span class="header_div">{{ ref }}</span>
            </Col>
          </Row>
        </div>
        <div style="text-align: center">
          <p class="font_size"></p>
          <div v-for="(item, index) in VRImg" :key="index">
            <img style="width: 80%" :src="item" alt="暂无图片" />
          </div>
        </div>
        <div slot="footer">
          <Button @click="modal1 = false">取消</Button>
          <!-- <Button type="primary" @click="goBuyGo">立即购买</Button> -->
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
export default {
  name: "SafetyEducation",
  data() {
    return {
      modal1: false,
      item01: [],
      ref: "",
      VRImg: [],
      photoArr1: [
        /*智能机器人*/
        {
          photoUrl: "../../../static/img/photo/photo_robot.jpg",
          photoUrl1: "../../../static/img/photo/photo_robot.jpg",
          p: "智能语音讲解、智能语音对讲、引导、安全质量讲解、服务型机器人+安全培训",
          VRImg: ["../../../static/img/photo/photo_robot.jpg"],
          ref: "智能机器人",
          money: "¥38000.00",
          classify: [
            {
              type: "",
              money: "￥38000.00",
              img: "../../../static/img/photo/photo_robot.jpg",
            },
          ],
          title: "安全教育",
          belong: "智能机器人",
          path: "/home/Buy/SafetyEducation",
        },
        // 电子沙盘
        {
          photoUrl: "../../../static/img/Content/ElectronicSand table.png",
          photoUrl1:
            "../../../static/img/Content/Interaction/Interaction02.jpg",
          p: "",
          VRImg: [
            "../../../static/img/Buy/Interaction/in01.png",
            "../../../static/img/Content/Interaction/Interaction02.jpg",
            "../../../static/img/Buy/Interaction/in03.png",
            "../../../static/img/Buy/Interaction/in04.png",
            "../../../static/img/Buy/Interaction/in05.png",
          ],
          ref: "党建  互动台  参观学习  漫游",
          money: "¥22000.00-￥36000.00",
          classify: [
            {
              type: "互动台电子沙盘（硬件部分）",
              money: "￥36000.00",
              img: "../../../static/img/photo-da/photo_dangjian.png",
            },
            {
              type: "模型设计（软件部分 定制）",
              money: "￥22000.00",
              img: "../../../static/img/photo-da/photo_dangjian.png",
            },
            {
              type: "程序设计（软件部分 定制）",
              money: "￥28000.00",
              img: "../../../static/img/photo-da/photo_dangjian.png",
            },
          ],
          title: "互动台电子沙盘",
          belong: "互动台电子沙盘",
          path: "/home/Buy/Interaction",
        },
        // 滑轨屏
        {
          photoUrl: "../../../static/img/Content/WisdomSlidingscreen.png",
          photoUrl1:
            "../../../static/img/Content/SlideScreen/SlideScreen01.png",
          p:
            "互动滑轨屏又称滑轨电视，形成结构由电子显示屏幕、轨道、红外感应器、主机、电机等组成，显示" +
            "屏可左右上下控制，安装形式多样，电子屏幕移动到预定定位时，将会显示播放对应的素材内容与背景形成" +
            "鲜明呼应，并与观众产生互动。电子显示屏可做多种选择，如OLED透明屏、触控-体机、 拼接屏等不同显示设备,具体可根据客户" +
            "需求定制。互动滑轨屏提供软件功能，可在电子屏幕上根据手指的动作放大.旋转、缩小等。",
          VRImg: [
            "../../../static/img/Content/SlideScreen/SlideScreen01.png",
            "../../../static/img/Content/SlideScreen/SlideScreen02.png",
            "../../../static/img/Content/SlideScreen/SlideScreen03.png",
            "../../../static/img/Content/SlideScreen/SlideScreen04.png",
          ],
          ref: "智慧滑轨屏",
          money: "¥22000.00-¥36000.00",
          classify: [],
          title: "互动滑轨屏",
          belong: "互动滑轨屏",
          path: "/home/Buy/SlideScreen",
        },
        // 全息投影系统
        {
          photoUrl: "../../../static/img/photo/全息投影系统.png",
          photoUrl1: "../../../static/img/photo/全息投影系统.png",
          p: "内置系统，高清展示可通过全息方式3d立体进行展示简洁大方，美观新颖（可定制）",
          VRImg: ["../../../static/img/photo/全息投影系统.png"],
          ref: "全息投影系统",
          money: "",
          classify: [],
          title: "全息投影系统",
          belong: "全息投影系统",
          path: "/home/Buy/SlideScreen",
        },
        // 全息投影系统
        {
          photoUrl: "../../../static/img/photo/全息系统.png",
          photoUrl1: "../../../static/img/photo/全息系统.png",
          p: "低成本便捷全息展示设备可展示视频，图片，动画等内容支持自动生成视频",
          VRImg: ["../../../static/img/photo/全息系统.png"],
          ref: "全息系统",
          money: "",
          classify: [],
          title: "全息系统",
          belong: "全息系统",
          path: "/home/Buy/SlideScreen",
        },
      ],
    };
  },
  methods: {
    onChange() {
      document
        .querySelector("body")
        .setAttribute("style", "overflow:hidden;padding-right:15px");
    },
    /*弹出对话框*/
    getMoney(item) {
      this.VRImg = item.VRImg;
      this.modal1 = true;
      this.item01 = item;
      this.ref = item.ref;
    },
    /*刚进页面的立即购买*/
    getMoney01(item) {
      this.goBuy(item);
    },
    /*弹出框里面立即购买*/
    goBuyGo() {
      this.modal1 = false;
      this.goBuy(this.item01);
      document.querySelector("body").setAttribute("style", "overflow:auto");
    },
    /*购买*/
    goBuy(item) {
      sessionStorage.setItem("title", item.title);
      sessionStorage.setItem("belong", item.belong);
      sessionStorage.setItem("path", item.path);
      sessionStorage.setItem("money", item.money);
      sessionStorage.setItem("ref", item.ref);
      sessionStorage.setItem("photoUrl1", item.photoUrl1);
      sessionStorage.setItem("classify", JSON.stringify(item.classify));
      this.$router.push({
        path: "/home/buyGo",
      });
    },
  },
};
</script>

<style>
.modal_div .ivu-modal-header p,
.modal_div .ivu-modal-header-inner {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}
/*面包屑*/
.col_bread .ivu-breadcrumb {
  font-size: 16px;
}
</style>
<style scoped>
/*弹出框字体*/
.header_div {
  color: #02a0e7;
  font-size: 20px;
  font-weight: bold;
  font-family: 新宋体, serif;
}

.font_size {
  font-size: 19px;
}

.buy_col01 {
  width: 270px;
  background: #f7f7f7;
  text-align: center;
  cursor: pointer;
  margin: 14px 0px 0 22px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}

.buy_col01:hover {
  box-shadow: 0 0 3px 3px rgba(0, 0, 0, 0.2);
}

.buy_col01 .sp:hover {
  color: red;
}

.buy_rule {
  width: 270px;
  height: 240px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.buy_rule img {
  width: 210px;
  height: 210px;
}

.sp {
  font-size: 14px;
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/components/Buy/SafetyEducation.vue